export default "__VITE_ASSET__c64c6910__"